import React from 'react';
import PropTypes from 'prop-types';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const SelectionList = ({ list, resultScore }) =>
    list.map(({ score, text }) => {
        const isScoresEqual = score === resultScore;
        return (
            <div
                key={generateReactKey(text)}
                className={`list-item ${isScoresEqual ? 'selected' : ''}`}
            >
                <span className="description">{text}</span>
                {score}
            </div>
        );
    });

SelectionList.defaultProps = {
    list: [],
    resultScore: 0,
};

SelectionList.propTypes = {
    list: PropTypes.array,
    resultScore: PropTypes.number,
};

export default SelectionList;
